
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemLinkType = typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemLinkType[keyof typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
